var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100%"},style:({height: _vm.height}),attrs:{"center":_vm.markers[0] || _vm.center,"zoom":_vm.zoom}},_vm._l((_vm.markers),function(m,index){return (_vm.markers.length)?_c('gmap-marker',{key:index,attrs:{"position":m},on:{"click":function($event){return _vm.setCenter(m)}}}):_vm._e()}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }